import { UPDATE_RECENT_ORDERS_WS, UPDATE_RECENT_ORDERS, UPDATE_LOGGED_IN_RECENT_ORDERS_WS, UPDATE_LOGGED_IN_RECENT_ORDERS, UPDATE_TIME_SUMMARY_WS, UPDATE_TIME_SUMMARY, SET_USERS } from './chunk-V4FTVBZY.mjs';
import { LOCATION_SETTINGS_INITIAL_STATE } from './chunk-PEXCKIGD.mjs';
import { SET_ROLE_DASHBOARDS, SET_SETTINGS_DASHBOARDS, REMOVED_PRINTER_WS, REMOVED_PRINTER, SET_PRINTERS, SET_PRINTER_STATUS_WS, SET_LOCATION_SETTINGS_WS, SET_LOCATION_SETTINGS } from './chunk-SKLRT3EJ.mjs';
import { __spreadValues } from './chunk-T36PI2YV.mjs';
import { produce } from 'immer';

var settingsLocationReducer = produce((state = LOCATION_SETTINGS_INITIAL_STATE, action) => {
  var _a;
  switch (action.type) {
    case SET_LOCATION_SETTINGS:
    case SET_LOCATION_SETTINGS_WS:
      return action.payload;
    case SET_USERS:
      state.users = __spreadValues(__spreadValues({}, state.users), action.payload);
      break;
    case UPDATE_TIME_SUMMARY:
    case UPDATE_TIME_SUMMARY_WS:
      state.users[action.payload.organizationUserId].shiftTimeSummary = action.payload;
      break;
    case SET_PRINTER_STATUS_WS:
      if (state.devices.printers[action.payload.printerId]) {
        state.devices.printers[action.payload.printerId].status = action.payload.status;
        if (action.payload.showInPrinterCenter !== void 0) {
          state.devices.printers[action.payload.printerId].showInPrinterCenter = action.payload.showInPrinterCenter;
        }
      }
      break;
    case SET_PRINTERS:
      state.devices.printers = action.payload;
      break;
    case UPDATE_LOGGED_IN_RECENT_ORDERS:
    case UPDATE_LOGGED_IN_RECENT_ORDERS_WS:
    case UPDATE_RECENT_ORDERS:
    case UPDATE_RECENT_ORDERS_WS:
      state.users[action.payload.organizationUserId].recentOrders = action.payload.recentOrders;
      break;
    case REMOVED_PRINTER:
    case REMOVED_PRINTER_WS: {
      const currentPrinters = state.devices.printers;
      (_a = action.payload) == null ? void 0 : _a.forEach((printerId) => {
        delete currentPrinters[printerId];
      });
      break;
    }
    case SET_SETTINGS_DASHBOARDS:
      state.dashboards = action.payload;
      break;
    case SET_ROLE_DASHBOARDS:
      state.roles[action.payload.roleId].dashboardIds = action.payload.dashboardIds;
      state.roles[action.payload.roleId].defaultDashboardId = action.payload.defaultDashboardId;
      break;
    default:
      return state;
  }
});
var reducers_default = settingsLocationReducer;

export { reducers_default };
